export default __webpack_public_path__ + "static/media/NotoSerif-Bold.2dc50d6c.woff2";